import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const premiumIcon = L.divIcon({
  html: `<div style="width:28px;height:28px;background:#134E34;color:#fff;display:grid;place-items:center;border:2px solid #fff;box-shadow:0 4px 12px rgba(0,0,0,.25);border-radius:2px;font:700 11px/1 Manrope, sans-serif;">★</div>`,
  className: "",
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

const freeIcon = L.divIcon({
  html: `<div style="width:14px;height:14px;background:#C8795A;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,.3);"></div>`,
  className: "",
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

const HAUT_RHIN_CENTER = [47.9, 7.3];

export default function MapView({ businesses, height = 480, single = false }) {
  const validPoints = businesses.filter((b) => typeof b.lat === "number" && typeof b.lon === "number");
  const center = single && validPoints[0] ? [validPoints[0].lat, validPoints[0].lon] : HAUT_RHIN_CENTER;
  const zoom = single ? 14 : 9;

  return (
    <div data-testid="map-view" style={{ height }}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} style={{ height: "100%", width: "100%", borderRadius: 4 }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {validPoints.map((b) => {
          const isP = b.premium && (b.premium.tier === "premium" || b.premium.tier === "premium_ai");
          return (
            <Marker key={b.id} position={[b.lat, b.lon]} icon={isP ? premiumIcon : freeIcon}>
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <div style={{ fontWeight: 700, marginBottom: 4 }}>{b.name}</div>
                  <div style={{ fontSize: 12, color: "#5C635A", marginBottom: 6 }}>{b.category} · {b.city}</div>
                  <a href={`/entreprise/${b.slug}`} style={{ color: "#134E34", fontWeight: 600, fontSize: 13 }}>Voir la fiche →</a>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
}
